import { ROUTE_UI_SECTION_NAME } from '../constants/route'

import {
  withCalendarMockSections,
  withCalendarMockUiSections,
} from './calendarMock'
import { getSectionCanViewPermission } from './common'

// TODO: check these gates against the real init once the backend ships
// TM-01-46 and rework them if the keys or the admin check differ
export function isCalendarAvailable(availableSections) {
  return withCalendarMockUiSections(availableSections)[
    ROUTE_UI_SECTION_NAME.calendar
  ]
}

export function isCalendarSettingsAvailable({ availableSections, sections }) {
  return (
    isCalendarAvailable(availableSections) &&
    getSectionCanViewPermission(
      withCalendarMockSections(sections),
      ROUTE_UI_SECTION_NAME.settingsCalendar
    )
  )
}
